import * as React from 'react';
import * as styles from './kendo-api-breadcrumb.module.scss';
import { usePageData } from '../../../hooks/page-data';
import Anchor from '../../anchor/anchor';
import ChevronDown from '../../icons/chevron-down';

/* eslint-disable jsx-a11y/no-static-element-interactions */
// the interactions are handled in the child button

const KendoApiBreadcrumbItem = ({ title, items }) => {
    const [isOpen, setIsOpen] = React.useState(false);

    return (
        <div className={styles.item} onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
            <button className={styles.itemBtn} onClick={() => setIsOpen(!isOpen)}>
                <div>{title}</div>
                <div><ChevronDown></ChevronDown></div>
            </button>
            {isOpen && <>
                <div className={styles.popover}>
                    {items.map((item) => <React.Fragment key={item.name}>
                        <Anchor className={styles.popoverItem} href={item.url}>{item.name}</Anchor>
                    </React.Fragment>)}
                </div>
            </>}
        </div>
    );
}

const KendoApiBreadcrumb = () => {
    const pageData = usePageData();

    const segments = React.useMemo(() => {
        const parts = pageData.kendoApiMember.name.split('.');

        const result = [];

        for (let i = 1; i <= parts.length; i++) {
            const parentName = parts.slice(0, i).join('.');
            result.push(parentName);
        };

        return result;
    }, [pageData.kendoApiMember.name]);

    const levelItemsMap = React.useMemo(() => {
        const map = new Map();

        pageData.breadCrumbMembers.group.forEach((group, ix) => {
            const parentName = ix === 0 ? null : `${segments[ix - 1]}.`;

            const items = group.nodes
                .filter((item) => !parentName || item.name.startsWith(parentName))
                .map((item) => ({ name: item.name, url: item.url }));

            map.set(group.fieldValue, items);
        });

        return map;
    }, [pageData.breadCrumbMembers.group, segments]);

    const memberTypes = React.useMemo(() => {
        const result = pageData.memberTypes.group.map((group) => {
            const name = group.type;
            const urlName = group.type.replaceAll(/[^0-9a-z]/gi, '-').toLowerCase();
            return {
                name,
                url: `${pageData.kendoApiMember.kendoApiType.url}#${urlName}`
            };
        });

        return result;
    }, [pageData]);

    return (
        <div className={`${styles.wrap} d-print-none`}>
            <div className={styles.item}>
                <Anchor href={pageData.kendoApiMember.kendoApiType.url}>{pageData.kendoApiMember.kendoApiType.name}</Anchor>
            </div>
            <KendoApiBreadcrumbItem title={pageData.kendoApiMember.type} items={memberTypes} />
            {
                segments.map((s, ix) => <React.Fragment key={s}>
                    <KendoApiBreadcrumbItem title={s} items={levelItemsMap.get(ix.toString())} />
                </React.Fragment>)
            }
        </div>
    );
}

export default KendoApiBreadcrumb;